import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "../additionalcss/style.css";
import Dashboard from "../components/Dashboard";

function DashboardD() {
  const location = useLocation();
  useEffect(() => {
    document.querySelector("html").style.scrollBehavior = "auto";
    window.scroll({ top: 0 });
    document.querySelector("html").style.scrollBehavior = "";
  }, [location.pathname]);
  return (
    <>
      <Dashboard />
    </>
  );
}

export default DashboardD;
